// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './bookingId.scss'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const BookingId = ({ VisitNumber, onClickBookingId, VisitId }) => {
  const onClickBookingIdLink = () => {
    onClickBookingId(VisitId)
  }

  return (
    <button type='button' className='visits-table-booking-id' onClick={onClickBookingIdLink}>
      {VisitNumber}
    </button>
  )
}

export default BookingId
